export function fieldErrorsToArray(fieldErrors) {
  if (!fieldErrors) return [];

  return Object.values(fieldErrors).reduce((allMessages, theseErrors) => allMessages.concat(theseErrors), []);
}
